function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M90 0.000976562H0V60.0016H90V0.000976562Z",
  fill: "#D80027"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M90 37.0114H35.5421V60.0006H32.2826H24.7813H21.5218V37.0114H0V33.75V26.2506V22.989H21.5218V0H24.7813H32.2826H35.5421V22.989H90V26.2506V33.75V37.0114Z",
  fill: "#F0F0F0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M90 26.2506V33.75H32.2826V60.0006H24.7813V33.75H0V26.2506H24.7813V0H32.2826V26.2506H90Z",
  fill: "#0052B4"
});

var SvgNok = function SvgNok(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 61,
    viewBox: "0 0 90 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNok, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NOK.cb8c7f1c.svg";
export { ForwardRef as ReactComponent };